import axios from "axios";
import MDButton from "components/MDButton";
import L from "leaflet";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import MiniMap from "leaflet-minimap";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Form, Row } from "reactstrap";
import { basicURL } from "../../apiManager/APIConfig";
import logo from "../../assets/images/logo.png";
import CustomDrawer from "../../components/CustomDrawer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { GetSlideByIdCall } from "../../redux/api/title.api";
import { store } from "../../redux/store";
import "./map.css";
import { DeleteFile } from "../../redux/api/upload.api";

function ShowTile({ history }) {
  const userData = history?.location?.state?.data?.array;

  const fileInputRef = useRef();
  const { id, lang } = useParams();
  const mapRef = useRef(null); // Ref for storing map instance

  const content = userData?.content;

  const [info, setInfo] = useState([]);
  const [geoJson, setGeoJson] = useState([]);

  const [showLoader, setShowLoader] = useState(false);
  const [uploadProgress, setUploadPercentage] = useState(0);

  const [drawerOpen, setOpenDrawer] = useState(false);
  const [activeDeleteButton, setActiveDeleteButton] = useState(false);

  const [tileURL, setTitleURL] = useState(``);

  useEffect(() => {
    fetchSlide();
  }, []);
  /////////
  /////////
  function generateUniqueId() {
    return "id-" + Math.random().toString(36).substr(2, 16);
  }
  const fetchSlide = async () => {
    const res = await GetSlideByIdCall({
      id,
      lang,
    });
    ////here ......
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
    setGeoJson(res);
    setActiveDeleteButton(res?.Files?.[0]?.url ? true : false);
    setTitleURL(`${res?.Files?.[0]?.url}/{z}/{x}/{y}.png`);
    // window.location.reload();
  };
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }

    if (!isEmpty(geoJson) && tileURL && !mapRef.current) {
      var map = L.map("map").setView([-10.505, -0.09], 2);
      L.tileLayer(tileURL, {
        attribution: '&copy; <a href="https://microlab.ink">Microlab</a> contributors',
      }).addTo(map);
      //////////
      const minimapLayer = L.tileLayer(tileURL, {
        maxZoom: 0,
        noWrap: true,

        detectRetina: true,
        minZoom: 0,
        bounds: [
          [-90, -180],
          [90, 180],
        ],
        maxNativeZoom: 0,
      });
      ////////
      ////////
      new MiniMap(minimapLayer, {
        zoomLevelFixed: 2,
        position: "bottomleft",
        width: 120,
        height: 120,
        collapsedWidth: 5,
        collapsedHeight: 5,
        aimingRectOptions: {
          color: "#00f",
          weight: 1,
          fillOpacity: 0.1,
        },
      }).addTo(map);

      /////////
      ///////// show the saved pins

      geoJson?.pins.forEach((pin) => {
        const location = JSON.parse(pin.locations);
        const coordinates = location.data.geometry.coordinates;
        const marker = L.marker([coordinates[1], coordinates[0]]).addTo(map);

        marker.on("click", () => {
          const titleLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "title" && loc.language === lang
          );
          const bodyLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "body" && loc.language === lang
          );

          const updatedPin = {
            ...pin,
            title: titleLocalization?.value,
            body: bodyLocalization?.value,
          };

          // Find the corresponding pin from the pins state
          setInfo(updatedPin); // Use updated pin data here
          setTimeout(() => {
            toggleDrawer(true);
          }, 200);
        });

        // You can also add a popup for each marker
        // const pinLocalization = pin.pinLocalizations?.find(
        //   (localization) => localization.language === "es"
        // );
        // marker.bindPopup(`
        //   <b>${
        //     pinLocalization?.field === "title" ? pinLocalization.value : "Untitled Pin"
        //   }</b><br />
        //   ${pinLocalization?.field === "body" ? pinLocalization.value : "No description"}
        // `);
      });
      /////////
      /////////
      // FeatureGroup is to store editable layers
      var drawnItems = new L.FeatureGroup();
      map.addLayer(drawnItems);
      var drawControl = new L.Control.Draw({
        position: "topright",
        edit: {
          featureGroup: drawnItems,
        },
      });
      map.addControl(drawControl);
      if (!isEmpty(geoJson?.pins)) {
        L.geoJSON(geoJson?.pins)
          .addTo(map)
          .on(
            "click",
            function (e) {
              const { layer } = e;

              const id = layer?.feature.properties.id;
              setInfo({ content: content[id], markerID: id });

              setTimeout(() => {
                toggleDrawer(true);
              }, 200);
            }.bind()
          );
      }
      ///////////////
      ///////////////
      ///////////////
      const watermark = L.control({ position: "bottomright" });
      watermark.onAdd = function (map) {
        const div = L.DomUtil.create("div", "watermark");
        div.style.background = "transparent"; // Ensure background is transparent
        div.innerHTML = `<img src=${logo} alt="Microlab Watermark" style="width: 100px; height: auto;">`;
        return div;
      };
      watermark.addTo(map);
      ///////////////
      ///////////////
      ///////////////
      ////Edit and add functions
      map.on("draw:created", function (e) {
        var type = e.layerType,
          layer = e.layer;

        console.log("layer draw:created : ", layer);
        if (type === "marker") {
          // showModal(layer);
          // Do marker specific actions
          const latlng = layer.getLatLng(); // Get latitude and longitude of the marker

          // Construct GeoJSON structure
          const geoJson = {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [latlng.lng, latlng.lat], // Leaflet uses lat/lng; GeoJSON uses lng/lat
            },
            properties: {
              id: generateUniqueId(), // Replace with your logic to generate an ID
            },
          };

          //   setInfo((prevInfo) => [...prevInfo, geoJson]);
          setInfo(geoJson);
        }
        if (type === "polyline" || type === "polygon" || type === "circle") {
          const latlngs = layer.getLatLngs(); // Get all points of the polyline

          // Construct GeoJSON for Polyline
          const geoJson = {
            type: "Feature",
            geometry: {
              type: type === "polyline" ? "LineString" : "polygon",
              coordinates: latlngs.map((latlng) => [latlng.lng, latlng.lat]), // Map to [lng, lat]
            },
            properties: {
              id: generateUniqueId(), // Replace with your logic to generate an ID
            },
          };
          //   setInfo((prevInfo) => [...prevInfo, geoJson]);
          setInfo(geoJson);
        }

        layer.on("click", (e) => {
          toggleDrawer(true);
        });
        ///////////////
        ///////////////
        ///////////////
        // Do whatever else you need to. (save to db; add to map etc)
        drawnItems.addLayer(layer);
      });

      map.addLayer(drawnItems);
      ///////////////
      ///////////////
      ///////////////
    }

    return () => {
      // Cleanup map on component unmount
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [tileURL]);

  const handleAddMaterial = async (event) => {
    if (activeDeleteButton) {
      const file_id = geoJson?.Files?.[0]?.id;
      const confirmation = window.confirm(
        "Are you sure you want to delete this slide? You pins will still remain on the screen."
      );
      if (confirmation) {
        DeleteFile(file_id);
        window.location.reload();
      }
    } else {
      const file = event.target.files[0];
      if (file) {
        try {
          setShowLoader(true);
          // Handle `.zip` file upload
          const formdata = new FormData();
          formdata.append("file", file);
          formdata.append("entity_type", "slide");
          formdata.append("entity_id", id);
          formdata.append("destination", "slides");
          formdata.append("folder_name", "slides");

          const access_token = store.getState().auth?.access_token;
          let myHeaders = new Headers();
          myHeaders.append("Authorization", access_token);

          myHeaders = {
            Authorization: access_token,
          };

          const response = await axios.post(`${basicURL}/file/upload`, formdata, {
            headers: myHeaders,
            onUploadProgress: (progressEvent) => {
              // Calculate the progress percentage
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              setUploadPercentage(percent);
            },
          });
          setShowLoader(false);
          setTitleURL(`${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`);

          console.log(
            "ZIP file uploaded:",
            `${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`
          );
          window.location.reload();
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    }
  };

  const toggleDrawer = (open) => {
    setOpenDrawer(open);
  };
  const uploaderTitle =
    uploadProgress != 100
      ? "uploadProgress: "
      : "Extracting the zip file and this may take a while ...";

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">
                  {!activeDeleteButton ? (
                    <div>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleAddMaterial}
                      />
                      <MDButton
                        style={{ marginBottom: 15 }}
                        color={"info"}
                        variant="contained"
                        onClick={() => fileInputRef.current.click()} // Trigger the hidden file input
                      >
                        Upload Slide
                      </MDButton>
                    </div>
                  ) : (
                    <MDButton
                      style={{ marginBottom: 15 }}
                      color={"primary"}
                      variant="contained"
                      onClick={() => handleAddMaterial()} // Trigger the hidden file input
                    >
                      Delete Slide
                    </MDButton>
                  )}
                </CardTitle>
                {showLoader && (
                  <CardBody>
                    <Form>
                      <div>
                        <div>
                          {uploaderTitle} {Math.round(uploadProgress)}%
                        </div>
                        <div style={{ marginBottom: 20, height: "10px", backgroundColor: "#ddd" }}>
                          <div
                            style={{
                              height: "100%",
                              width: `${uploadProgress}%`,
                              backgroundColor: "green",
                            }}
                          ></div>
                        </div>
                      </div>
                    </Form>
                  </CardBody>
                )}
              </CardHeader>
              <CardBody>
                <Form>
                  <div id={"map"} style={{ width: "100%", height: "70vh" }} />
                  <CustomDrawer
                    data={info}
                    lang={lang}
                    slide_id={id}
                    fetchSlide={fetchSlide}
                    open={drawerOpen}
                    toggleDrawer={toggleDrawer}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </DashboardLayout>
  );
}

export default ShowTile;
